// Vue
import {mixins} from 'vue-class-component'
import {CreateElement} from 'vue'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Mixins
import {EventBus} from '../../../mixins/event_bus/EventBus'

// Template
import template from './template.vue'

// Components
import {Button} from '../button/Button'
import {Icon} from '../icon/Icon'
import {LightboxImg} from '../lightbox_img/LightboxImg'
import {SliderItemImg} from './item_img/SliderItemImg'
import {P} from '../p/P'

@Component({
    name: 'Slider',
    components: {
        Button,
        Icon,
        LightboxImg,
        SliderItemImg,
        P,
    },
    mixins: [
        template
    ]
})
export class Slider extends mixins(EventBus) {

    public get lightboxVideoComponentName() {

        const prefix = APP_PREFIX.toLowerCase()

        const camelCasePrefix = prefix.charAt(0).toUpperCase() + prefix.slice(1)

        return camelCasePrefix + 'LightboxVideo'
    }

    public get sliderLength() {
        return Object.keys(this.registeredSlides).length
    }

    public get activeSlideIndex() {
        const activeSlideIndex = Object.values(this.registeredSlides).findIndex(slide => slide.id == this.activeSlideId )

        if (activeSlideIndex == -1) return 1

        return activeSlideIndex + 1
    }

    public lightboxProps: any = {}
    public isLightboxOpen: boolean = false

    public isDestroyed = false

    public isMobile = false

    public activeSlideId: string | null = null
    public activeTransitionSlideIndex: number = 0;
    
    public slides: any[] = []
    public registeredSlides: object =  {}

    public isDragging: boolean = false
    public startDraggingPoint: number = 0

    public isTransitioning: boolean = false

    public animationTimeoutId!: any

    public checkVisibleIntervalId!: any

    private width: number = 0

    @Prop({default: 'default'})
    public theme!: string

    @Prop({default: true})
    public animated!: boolean

    @Prop({default: 2500})
    public duration!: number

    @Watch('activeSlideId')
    private watchRegisteredSlides(newActiveSlideId, oldActiveSlideId) {

        let activeSlide

        const activeSlideIndex = Object.values(this.registeredSlides).findIndex(slide => (slide as any).id == newActiveSlideId)

        if (activeSlideIndex == -1) activeSlide = 1

        activeSlide = activeSlideIndex + 1

        this.$emit('change', activeSlide)
    }

    public $refs!: {
        slider_body: HTMLElement
    }

    get wrapStyles() {
        return {
            width: (this.slides.length * this.width) + 'px',
            transform: 'translateX(-' + ((this.activeTransitionSlideIndex * this.width)) + 'px)'
        }
    }

    public created() {

        this.$on('registerSlide', this.handleRegisterSlide)
        this.$on('animatedState', this.handleAnimatedStateChange)

        window.addEventListener('resize', this.handleResize)
    }

    public mounted () {

        this.handleResize(undefined)

        this.initSlider()

        const slidesWrap = <HTMLElement>this.$refs['slides_wrap']
        slidesWrap.addEventListener('transitionend', this.handleTransitionEnd)
    }

    public beforeDestroy() {

        this.$off('registerSlide', this.handleRegisterSlide)
        this.$off('animatedState', this.handleAnimatedStateChange)

        window.removeEventListener('resize', this.handleResize)

        const slidesWrap = <HTMLElement>this.$refs['slides_wrap']
        slidesWrap.removeEventListener('transitionend', this.handleTransitionEnd)

        clearInterval(this.checkVisibleIntervalId)

        this.isDestroyed = true
    }

    public destroyed() {

    }

    public handleAnimatedStateChange(state: boolean) {
        this.$emit('animated', state);
        if (state == false) {
            clearTimeout(this.animationTimeoutId)
        }
    }

    public handleRegisterSlide(slide: any) {

        slide.id = this.guid()

        Vue.set(this.registeredSlides, slide.id, slide)
    }

    public handlePrev() {

        if (this.isTransitioning || this.slides.length < 2) return

        this.stopAnimation()

        const slidesWrap = <HTMLElement>this.$refs['slides_wrap']

        this.isTransitioning = true

        const activeSlideIndex = this.slides.findIndex(slide => slide.active)

        this.slides[activeSlideIndex - 1].active = true
        this.slides[activeSlideIndex].active = false

        this.activeSlideId = this.slides[activeSlideIndex - 1].id

        this.$nextTick(() => {

            const sliderWidth = this.$refs.slider_body.offsetWidth

            this.activeTransitionSlideIndex = activeSlideIndex - 1
            this.width = sliderWidth
        })
    }

    public handleNext() {

        if (this.isTransitioning || this.slides.length < 2) return

        this.stopAnimation()

        const slidesWrap = <HTMLElement>this.$refs['slides_wrap']

        this.isTransitioning = true

        const activeSlideIndex = this.slides.findIndex(slide => slide.active)

        this.slides[activeSlideIndex + 1].active = true
        this.slides[activeSlideIndex].active = false

        this.activeSlideId = this.slides[activeSlideIndex + 1].id

        this.$nextTick(() => {

            const sliderWidth = this.$refs.slider_body.offsetWidth

            this.activeTransitionSlideIndex = activeSlideIndex + 1
            this.width = sliderWidth
        })
    }

    public handleGoToId(id: string) {

        if (this.isTransitioning || this.activeSlideId == id) return

        this.stopAnimation()

        const slidesWrap = <HTMLElement>this.$refs['slides_wrap']

        this.isTransitioning = true

        const currentActiveSlideIndex = this.slides.findIndex(slide => slide.active)
        const activeSlideIndex = this.slides.slice(2,this.slides.length - 2).findIndex(slide => slide.id == id)

        this.slides[activeSlideIndex + 2].active = true
        this.slides[currentActiveSlideIndex].active = false

        this.activeSlideId = this.slides[activeSlideIndex + 2].id

        this.$nextTick(() => {

            const sliderWidth = this.$refs.slider_body.offsetWidth

            this.activeTransitionSlideIndex = activeSlideIndex + 2
            this.width = sliderWidth
        })
    }

    public initSlider() {

        let activeSlideId

        clearInterval(this.checkVisibleIntervalId)
        this.stopAnimation()

        const registeredSlides = Object.values(this.registeredSlides)

        this.slides = registeredSlides.map(slide => {

            const cloneSlide = JSON.parse(JSON.stringify(slide))

            if (cloneSlide.active) activeSlideId = cloneSlide.id

            return cloneSlide
        })

        if (this.slides.length > 1) {

            const startClonedSlides = registeredSlides.slice(-2).map(slide => {

                const cloneSlide = JSON.parse(JSON.stringify(slide))

                // cloneSlide.id = this.guid()

                cloneSlide.active = false
                return cloneSlide
            })

            const endClonedSlides = registeredSlides.slice(0, 2).map(slide => {

                const cloneSlide = JSON.parse(JSON.stringify(slide))

                cloneSlide.active = false
                // cloneSlide.id = this.guid()

                return cloneSlide
            })

            this.slides = startClonedSlides.concat(this.slides).concat(endClonedSlides)

            if (!activeSlideId) {
                this.slides[2].active = true
            }

            this.activeSlideId = activeSlideId || this.slides[2].id

            this.$nextTick(() => {

                const slidesWrap = <HTMLElement>this.$refs['slides_wrap']

                const activeSlideIndex = this.slides.findIndex(slide => slide.active)

                this.activeSlideId = this.slides[activeSlideIndex].id

                const sliderWidth = this.$refs.slider_body.offsetWidth

                if (sliderWidth > 0) {

                    this.activeTransitionSlideIndex = activeSlideIndex
                    this.width = sliderWidth

                    if (this.animated) {
                        this.startAnimation()
                    }
                } else {

                    clearInterval(this.checkVisibleIntervalId)

                    this.checkVisibleIntervalId = setInterval(() => {

                        const sliderWidth = this.$refs.slider_body.offsetWidth

                        if (sliderWidth > 0) {

                            clearInterval(this.checkVisibleIntervalId)

                            this.activeTransitionSlideIndex = activeSlideIndex
                            this.width = sliderWidth

                            if (this.animated) {
                                this.startAnimation()
                            }
                        }
                    }, 500)
                }
            })
        } else {

            if (!activeSlideId) {
                this.slides[0].active = true
            }

            this.activeSlideId = activeSlideId || this.slides[0].id

            this.$nextTick(() => {

                const slidesWrap = <HTMLElement>this.$refs['slides_wrap']

                const activeSlideIndex = this.slides.findIndex(slide => slide.active)

                this.activeSlideId = this.slides[activeSlideIndex].id

                const sliderWidth = this.$refs.slider_body.offsetWidth

                if (sliderWidth > 0) {
                    this.activeTransitionSlideIndex = activeSlideIndex
                    this.width = sliderWidth
                } else {
                    this.checkVisibleIntervalId = setInterval(() => {

                        const sliderWidth = this.$refs.slider_body.offsetWidth

                        if (sliderWidth > 0) {

                            clearInterval(this.checkVisibleIntervalId)

                            this.activeTransitionSlideIndex = activeSlideIndex
                            this.width = sliderWidth
                        }
                    }, 500)
                }
            })
        }
    }

    public startAnimation() {

        if (this.isTransitioning) return

        const activeSlideIndex = this.slides.findIndex(slide => slide.active)

        const currentSlideDuration = this.slides[activeSlideIndex].duration || this.duration

        this.animationTimeoutId = setTimeout(() => {

            const slidesWrap = <HTMLElement>this.$refs['slides_wrap']

            const activeSlideIndex = this.slides.findIndex(slide => slide.active)

            this.isTransitioning = true

            this.slides[activeSlideIndex + 1].active = true
            this.slides[activeSlideIndex].active = false

            this.activeSlideId = this.slides[activeSlideIndex + 1].id

            this.$nextTick(() => {

                if (this.isDestroyed) return

                const sliderWidth = this.$refs.slider_body.offsetWidth

                if (sliderWidth > 0) {
                    this.activeTransitionSlideIndex = activeSlideIndex + 1
                    this.width = sliderWidth
                } else {

                    clearInterval(this.checkVisibleIntervalId)

                    this.checkVisibleIntervalId = setInterval(() => {

                        const sliderWidth = this.$refs.slider_body.offsetWidth

                        if (sliderWidth > 0) {

                            clearInterval(this.checkVisibleIntervalId)

                            this.activeTransitionSlideIndex = activeSlideIndex + 1
                            this.width = sliderWidth
                        }
                    }, 500)
                }
            })
        }, currentSlideDuration)
    }

    public stopAnimation() {

        clearTimeout(this.animationTimeoutId)
    }

    public handleTouchStart(e: MouseEvent | TouchEvent) {
        this.isDragging = true
        if ((e as TouchEvent).touches) {
            this.startDraggingPoint = (e as TouchEvent).touches[0].clientX
        } else {
            this.startDraggingPoint = (e as MouseEvent).clientX
        }
    }

    public handleTouchMove(e: MouseEvent) {
        if (!this.isDragging) return
    }

    public handleTouchEnd(e: MouseEvent | TouchEvent) {
        this.isDragging = false

        const clientX = (e as TouchEvent).changedTouches
            ? (e as TouchEvent).changedTouches[0].clientX
            : (e as MouseEvent).clientX

        if (clientX - this.startDraggingPoint > 10) {
            this.handlePrev()
        } else if (clientX - this.startDraggingPoint < -10) {
            this.handleNext()
        }
    }

    public handleTransitionEnd(e: Event) {
        if (e.target == this.$refs['slides_wrap']) {
            this.isTransitioning = false

            this.stopAnimation()

            const slidesWrap = <HTMLElement>this.$refs['slides_wrap']

            const activeSlideIndex = this.slides.findIndex(slide => slide.active)

            if (activeSlideIndex == 1) {

                this.slides[this.slides.length - 3].active = true
                this.slides[activeSlideIndex].active = false

                this.$nextTick(() => {

                    const slide = <HTMLElement>this.$refs[`slide-${this.slides.length - 3}`][0]
                    const slidePrev = <HTMLElement>this.$refs[`slide-${this.slides.length - 4}`][0]
                    const slideNext = <HTMLElement>this.$refs[`slide-${this.slides.length - 2}`][0]

                    slide.style.transition = 'none'
                    slidePrev.style.transition = 'none'
                    slideNext.style.transition = 'none'

                    const sliderWidth = this.$refs.slider_body.offsetWidth

                    this.activeTransitionSlideIndex = this.slides.length - 3
                    this.width = sliderWidth

                    slide.style.transition = ''
                    slidePrev.style.transition = ''
                    slideNext.style.transition = ''
                })

            } else if (activeSlideIndex == (this.slides.length - 2)) {

                this.slides[2].active = true
                this.slides[activeSlideIndex].active = false

                this.$nextTick(() => {

                    const slide = <HTMLElement>this.$refs[`slide-${2}`][0]
                    const slidePrev = <HTMLElement>this.$refs[`slide-${1}`][0]
                    const slideNext = <HTMLElement>this.$refs[`slide-${3}`][0]

                    slide.style.transition = 'none'
                    slidePrev.style.transition = 'none'
                    slideNext.style.transition = 'none'

                    const sliderWidth = this.$refs.slider_body.offsetWidth

                    this.activeTransitionSlideIndex = 2
                    this.width = sliderWidth

                    slide.style.transition = ''
                    slidePrev.style.transition = ''
                    slideNext.style.transition = ''
                })
            }

            if (this.animated) this.startAnimation()
        }
    }

    public handleResize(e?: any) {
        const windowWidth = document.documentElement!.clientWidth || document.body.clientWidth

        this.isMobile = windowWidth < 768

        if(e) this.initSlider()
    }

    public handleLightbox(props: {imgSrc?: string, bgSrc?: string, lazyloadingImg?: string, videoSrc?: string, videoPoster?: string, title?: string}) {

        this.lightboxProps = props
        this.isLightboxOpen = true
    }

    public guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1)
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
    }
}